import {signInWithCustomToken, signOut} from 'firebase/auth';
import {doc, onSnapshot} from 'firebase/firestore';
import {auth, firestore} from '../firebase';

export class FirebaseService {

  constructor() {
    this.inboxIndex = -1;
    this.inboxHandlers = {};
    this.inboxCount = 0;

    this.tasksIndex = -1;
    this.tasksHandlers = {};
    this.tasks = [];
  }

  async signIn(token) {
    return signInWithCustomToken(auth, token)
      .then((credentials) => {
        onSnapshot(doc(firestore, 'counts', process.env.REACT_APP_FIREBASE_ENV), snapshot => {
          const data = snapshot.data();
          if (data) {
            this.inboxCount = data.inbox ?? 0;
            for (let handler of Object.values(this.inboxHandlers)) {
              handler(this.inboxCount);
            }
          }
        }, () => null);
        onSnapshot(doc(firestore, `tasks-${process.env.REACT_APP_FIREBASE_ENV}`, credentials.user.uid),
          snapshot => {
            const data = snapshot.data();
            if (data) {
              this.tasks = JSON.parse(data.data) ?? [];
              for (let handler of Object.values(this.tasksHandlers)) {
                handler(this.tasks);
              }
            }
          }, () => null);
      });
  }

  async signOut() {
    return signOut(auth);
  }

  subscribeToInbox(handler) {
    const index = this.inboxIndex += 1;
    this.inboxHandlers[`${index}`] = handler;
    handler(this.inboxCount);
    return () => delete this.inboxHandlers[`${index}`];
  }

  subscribeToMyTasks(handler) {
    const index = this.tasksIndex += 1;
    this.tasksHandlers[`${index}`] = handler;
    handler(this.tasks);
    return () => delete this.tasksHandlers[`${index}`];
  }
}
